import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../firebase/config";
import { doc, setDoc, getDoc } from "firebase/firestore";

const DeliveryPartnerRegistration = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    area: "",
    aadhaar: "",
    license: "",
    rc: ""
  });
  const [loading, setLoading] = useState(false);

  // ✅ Get current user from Firebase Auth (for UID only)
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((u) => {
      if (u) {
        setUser(u);
        // Do NOT prefill phone/email anymore
        setForm((prev) => ({
          ...prev,
          name: u.displayName || ""
        }));
      } else {
        navigate("/delivery-partner/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, phone, area, aadhaar, license, rc } = form;

    if (!name || !phone || !area || !aadhaar || !license || !rc) {
      alert("Please fill in all fields.");
      return;
    }

    setLoading(true);

    try {
      const docRef = doc(db, "users", user.uid);
      const existing = await getDoc(docRef);

      if (existing.exists() && existing.data().status === "approved") {
        alert("You are already registered and approved.");
        navigate("/partner/dashboard");
        return;
      }

      await setDoc(docRef, {
        uid: user.uid,
        email: user.email || "",
        name,
        phone,
        area,
        aadhaar,
        license,
        rc,
        role: "deliveryPartner",
        status: "pending",
        createdAt: new Date().toISOString()
      });

      alert("✅ Registration submitted successfully. Awaiting admin approval.");
      navigate("/delivery-partner/pending");
    } catch (error) {
      console.error("Error registering partner:", error);
      alert("❌ Failed to register. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-green-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-lg">
        <h2 className="text-2xl font-bold text-green-700 mb-6 text-center">
          Delivery Partner Registration
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input label="Full Name" name="name" value={form.name} onChange={handleChange} />
          <Input label="Phone / Email" name="phone" value={form.phone} onChange={handleChange} />
          <Input label="Area" name="area" value={form.area} onChange={handleChange} />
          <Input label="Aadhaar Number" name="aadhaar" value={form.aadhaar} onChange={handleChange} />
          <Input label="Driving License Number" name="license" value={form.license} onChange={handleChange} />
          <Input label="RC Number" name="rc" value={form.rc} onChange={handleChange} />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition"
          >
            {loading ? "Submitting..." : "Submit Registration"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ✅ Input field component
const Input = ({ label, name, value, onChange }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <input
      type="text"
      name={name}
      value={value}
      onChange={onChange}
      className="w-full border border-gray-300 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
    />
  </div>
);

export default DeliveryPartnerRegistration;
